<template>
  <div id="story" class="story">
    <!-- <div class="background-image-container" :style="{ backgroundImage: backgroundImage }"></div> -->
    <!-- <div class="width-constraint"> -->
      <!-- <div v-if="$mq.resize && $mq.size('xxs')" class="image" :style="{ backgroundImage: backgroundImage }"></div> -->
      <div class="content-box content-box-padding">
        <div class="container-fluid container-fluid-responsive">
          <div class="row gutter-responsive">
            <div class="col-12 col-md-7">
              <div class="status-change margin-bottom-2 warning" v-if="showCompanyStatus">
                <span>BEMÆRK! VIRKSOMHEDENS NUVÆRENDE STATUS ER "{{entity.lastStatusChange.value}}"</span>
              </div>
              <div class="margin-bottom-1" style="color: #616161">Udgivet {{story.time | timeSince}}</div>
              <h1 class="t-name margin-top-0" style="margin-bottom: 8px;" v-html="story.prettyHeadline" />
              <h2 class="tagline padding-top-1" v-html="htmlTagline"></h2>
              <p class="margin-top-2 margin-bottom-0 text-semimuted story-content"><dynamic :comps="[contentComponent]" :emptyView="{template: '<span></span>'}"></dynamic></p>
              <LassoxSignupWall v-if="showSignupWall" path="news"></LassoxSignupWall>

              <template v-for="(st, index) in statstidende">
                <div class="text-semimuted story-content margin-top-2 margin-bottom-0" :key="index">
                  I Statstidende skrives der:
                  <blockquote class="blockquote text-muted" style="white-space: pre-wrap"><span v-html="linkify(st)"></span></blockquote>
                </div>
              </template>

              <div v-if="story.type === 'Account' && storyRelatedAccount" class="padding-top-2 story-context">
                <a v-show="storyRelatedAccount.reportUrl" class="btn btn-md btn-default btn-shadow margin-top-1" :href="storyRelatedAccount.reportUrl" target="_blank"><span class="btn-icon filetype pdf">PDF</span> HENT REGNSKAB</a>
                <accounts-viewer v-if="storyRelatedAccount.xbrlUrl" :thousands="true" :accounts="[storyRelatedAccount]" :compact="true" :cvr="entity.company.localIdentifier" class="margin-top-2 padding-top-1" />
              </div>
              <div v-if="ownershipRelated" class="ownershipdiagram-container">
                <LassoxLink class="ownershipdiagram-lassox-button" trackingEventName="ownershipdiagram+tease+click" path="ownershipdiagram"
                  :dialogOptions="{ lassoxIntro:
                    {
                      title: 'Se ejerdiagram',
                      text: 'Opret en profil og få større indsigt i dansk erhvervsliv. Du får bl.a. adgang til nye værktøjer og flere oplysninger om regnskaber, historik og ejerforhold – alt sammen helt gratis.',
                      image: require('@/assets/img/signup-dialog-ownership.png'),
                      color: 'pink'
                    }
                  }"
                >
                  <Button theme="red" icon="account_tree_outline_rounded" label="Se ejerdiagram" class="ownershipdiagram-lassox-button"></Button>
                </LassoxLink>
                <img  class="ownershipdiagram-image"  src="@/assets/img/ownershipdiagram.png" alt="Ejerdiagram" />
              </div>
            </div>
            <div class="col-12 col-md-5">
              <div class="d-block d-md-none margin-top-2 padding-top-1"></div>
              <div v-if="windowSize.width > windowSize.sizes.sm" class="margin-bottom-2 padding-bottom-1 d-flex flex-wrap" style="gap: 8px;">
              </div>
              <h4 class="margin-top-0 margin-bottom-1"><router-link exact :to="{ name: 'company', params: { id: entity.company.localIdentifier, name: $store.state.names[entity.lassoId] } }">{{entity.company.name}}</router-link></h4>
              <div class="text-semimuted contact-info">
                <div v-if="entity.commerciallyProtected"><i class="fa fa-exclamation-triangle" style="margin-right: 5px; color:#F6AC15"></i>Reklamebeskyttet</div>
                <div>{{entity.company.address1}}, {{entity.company.postalCode}} {{entity.company.city}}, {{entity.company.country}}</div>
                <div>CVR: {{entity.company.localIdentifier}}</div>
              </div>
              <div v-if="windowSize.width < windowSize.sizes.sm" class="margin-top-bottom-2 padding-bottom-2 d-flex flex-wrap" style="gap: 8px;">
                <Button
                  theme="red"
                  icon="speed"
                  label="Lav gratis kreditvurdering"
                  class="plausible-event-name=news+creditsafe+signup+button+click"
                  @click="() => userStore.showLoginToShowCompanyDialog({
                    lassoId: entity.lassoId,
                    trackingEventName: 'creditsafe+news+signup+button+click',
                    ...creditsafeIntro,
                  })"
                />
              </div>
              <!-- Not shown in freemium, so shouldn't be here either ... Probably
              <expandable-list v-if="storyRelatedAccount && storyRelatedAccount.xmlUrl" :open="true" :title="'ÅRSREGNSKAB ' + getAccountYear(storyRelatedAccount)" class="margin-top-2">
                <div class="row padding-top-1">
                  <div class="col-6 text-center">
                    <donut-chart title="Afkastningsgrad" :key-value="storyRelatedAccount.roi" :percentage="true"></donut-chart>
                  </div>
                  <div class="col-6 text-center">
                    <donut-chart title="Soliditetsgrad" :key-value="storyRelatedAccount.solvencyRatio" :percentage="true"></donut-chart>
                  </div>
                </div>
              </expandable-list> -->
              <expandable-list v-if="entity.management.length" title="DIREKTION" :open="true" class="text-semimuted padding-top-2 compact">
                <div class="list-element" v-for="(participant, index) in entity.management.map(o => o.participant)" :key="index"><participant-link :participant="participant" /></div>
              </expandable-list>
              <expandable-list v-if="entity.board.length" title="BESTYRELSE" :open="true" class="text-semimuted padding-top-2 compact">
                <div class="list-element" v-for="(participant, index) in entity.board.map(o => o.participant)" :key="index"><participant-link :participant="participant" /></div>
              </expandable-list>
            </div>
          </div>
        </div>
      </div>

      <!-- <webinar-new style="margin-top: 30px" /> -->
      <!-- <ebook style="margin-top: 30px" /> -->

      <news-feed v-if="entity.news" :name="entity.company.name" :news="entity.news" :loading="loadingNews" feed-type="entity-related" :is-query-related="false"></news-feed>
      <script v-html="structuredData" type="application/ld+json"></script>
  </div>
</template>

<script>
import Vue from 'vue'
import { store } from '@/assets/js/store.js'
import { EventBus, Story } from '@/assets/js/helpers.js'
import Directives from '@/assets/js/directives.js'
import DonutChart from '@/components/DonutChart'
import ExpandableList from '@/components/ExpandableList'
import ParticipantLink from '@/components/ParticipantLink'
import AccountsViewer from '@/components/AccountsViewer'
import LassoxSignupWall from '@/components/LassoxSignupWall'
import NewsFeed from '@/components/NewsFeed'
import Ebook from '@/components/Ebook'
import Button from '@/components/Button'
import WebinarNew from '@/components/WebinarNew.vue'
import windowSize from '@/window-size'
import userStore, { creditsafeIntro } from '@/modules/users/store'
import LassoxLink from '@/components/LassoxLink.vue'
import { trackGoal } from '@/utils/plausible'

export default {
  name: 'story',
  data () {
    return {
      windowSize,
      userStore,
      loadingNews: false,
      creditsafeIntro,
    }
  },
  created () {
  },
  computed: {
    story: function () {
      return this.$store.state.stories[this.$route.params.storyId]
    },
    entity: function () {
      return this.$store.state.entities[this.$route.meta.lassoIdPrefixes + this.$route.params.id]
    },
    contactCollection () {
      return this.entity.contactCollection
    },
    hasContacts () {
      return !!this.contactCollection?.contacts.length
    },
    statstidende: function () {
      return this.story ? (this.story.statstidende || []) : []
    },
    showSignupWall () {
      const paragraphs = this.story.content.split(' ')
      return paragraphs.length > 200
    },
    latestAccount: function () {
      return this.entity.lastAccounts.length ? this.entity.lastAccounts[0] : null
    },
    latestAccountYear: function () {
      return this.latestAccount ? new Date(this.latestAccount.period.to).getFullYear() : ''
    },
    // should be moved to own component along with all contextual views
    storyRelatedAccount: function () {
      var storyDate = new Date(this.story.time)
      if (this.entity.lastAccounts.length) {
        // get the account closest to publicationDate
        var closest = null
        var closestDaysBetween = null
        this.entity.lastAccounts.forEach((a) => {
          var daysBetween = Vue.filter('daysBetween')(storyDate, new Date(a.publicationTime))
          if (daysBetween < 15 && (!closestDaysBetween || (daysBetween < closestDaysBetween))) {
            closest = a
            closestDaysBetween = daysBetween
          }
        })
        return closest // could be null if nothing was found
      } else return null
    },
    contentComponent: function () {
      let storyContent = this.story.content
      return { template: '<span>' + Vue.filter('linkify')(storyContent, false, false, this.$store.state.names) + '</span>' }
    },
    htmlContent: function () {
      return Vue.filter('linkify')(this.story.content, false)
    },
    htmlTagline: function () {
      return Vue.filter('linkify')(this.story.tagLine, false)
    },
    backgroundImage: function () {
      switch (windowSize.size) {
        case 'xxs': return 'url(' + this.story.imageId.replace('.jpg', '_480.jpg') + ')'
        case 'xs': return 'url(' + this.story.imageId.replace('.jpg', '_768.jpg') + ')'
        case 'sm': return 'url(' + this.story.imageId.replace('.jpg', '_992.jpg') + ')'
        case 'md': return 'url(' + this.story.imageId.replace('.jpg', '_1200.jpg') + ')'
        case 'lg': return 'url(' + this.story.imageId.replace('.jpg', '_1200.jpg') + ')'
      }
    },
    showCompanyStatus: function () {
      // in some cases we want to emphasize that a company's current status is no longer what is reflected in the article.
      if (this.story) {
        switch (this.story.storyId) {
          case '8.3':
            if (this.entity && this.entity.lastStatusChange.value.toLowerCase().indexOf('opløsning') === -1) return true
            break
        }
        return false
      }
    },
    ownershipRelated() {
      return [ '2.25','2.26','2.27','2.28','2.29',
        '3.1','3.2','3.3','3.4','3.5','3.6',
        '4.3','39.0'
      ].includes(this.story.storyId)
    },
    structuredData() {
      return {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "headline": this.story.prettyHeadline,
        "datePublished": this.story.time,
        "author": {
          "@type": "Organization",
          "name": "Lasso X",
          "url": "https://www.lassox.com/"
        },
        "isAccessibleForFree": !this.showSignupWall,
        ...(this.showSignupWall &&
        {
          "hasPart":
          {
            "@type": "WebPageElement",
            "isAccessibleForFree": !this.showSignupWall,
            "cssSelector": ".walledText"
          }
        }
        )
      }
    }
  },
  methods: {
    loadNews: function (more) {
      var that = this
      if (this.loadingNews || (this.entity.news && (!more || this.entity.news.endReached))) return
      else this.loadingNews = true
      var nextPage = this.entity.news && more ? this.entity.news.page + 1 : 1
      this.$store.dispatch('loadEntityNews', { lassoId: this.entity.lassoId, page: nextPage, count: 12 }).then(() => { this.loadingNews = false })
      // Story.getByLassoIds([this.entity.lassoId], nextPage, 12).then(function (news) {
      //   that.$store.commit('addEntityNews', { lassoId: that.entity.lassoId, news: news, page: nextPage, endReached: news.length < 12 })
      //   that.loadingNews = false
      // })
    },
    getAccountYear: function (account) {
      return account ? new Date(account.period.to).getFullYear() : ''
    },
    linkify: function (htmlText) {
      return Vue.filter('linkify')(htmlText)
    }
  },
  mounted: function () {
    var that = this
    EventBus.$on('loadNews', function () { that.loadNews(true) })
    if (this.story)
      trackGoal('Visit News Story', {
        props: {
          id: this.story.storyId,
          type: this.story.type,
          provider: this.story.provider,
        },
      })
  },
  destroyed: function () {
    EventBus.$off('loadNews')
  },
  beforeRouteEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('loadStory', { lassoId: to.meta.lassoIdPrefixes + to.params.id, storyId: to.params.storyId }),
      store.dispatch('loadEntity', { lassoId: to.meta.lassoIdPrefixes + to.params.id, includeNews: true })
    ]).then(() => next())
  },
  beforeRouteUpdate: function (to, from, next) {
    Promise.all([
      this.$store.dispatch('loadStory', { lassoId: to.meta.lassoIdPrefixes + to.params.id, storyId: to.params.storyId }),
      this.$store.dispatch('loadEntity', { lassoId: to.meta.lassoIdPrefixes + to.params.id, includeNews: true })
    ]).then(() => next())
  },
  components: {
    DonutChart,
    ExpandableList,
    ParticipantLink,
    AccountsViewer,
    NewsFeed,
    Ebook,
    WebinarNew,
    Button,
    LassoxSignupWall,
    LassoxLink,
  },
  directives: {
    'clipboard': Directives.clipboard
  }
}
</script>

<style lang="less">
@import (reference) "~@oldShared/lasso/style/constants/colors";
  #story {
    position: relative;

    // .width-constraint {
    //   margin: 0 auto;
    // }

    .status-change {
      border-radius: 2px;
      text-align: center;
      font-size: 11px;
      font-weight: bold;
      padding: 8px;
      &.danger {
        color: @red-primary;
        background-color: #fadddd;
      }
      &.warning {
        color: #cc7606;
        background-color: #f7ebda;
      }
    }

    .image {
      background-size: cover;
      min-height: 200px;
    }

    .tagline {
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      margin: 0;
    }

    .story-content {
      line-height: 26px;
      a {
        color: #616161;
      }
      ul {
        margin: 10px 0;
      }
      blockquote {
        font-size: 15px !important;
        margin: 15px 0 !important;
        padding: 10px 20px;
        border-left: 5px solid #eee;
      }
    }

    .contact-info {
      line-height: 28px;
    }

    // .background-image-container {
    //   background-repeat: no-repeat;
    //   background-size: cover;
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   z-index: -1;
    //   height: 600px;
    //   max-height: 600px;
    //   width: 100%;
    // }
  }

  // #app.xs, #app.sm, #app.md {
  //   #story {
  //     padding-top: 50px;
  //   }
  // }

  // #app.lg {
  //   #story {
  //     padding-top: 100px;
  //   }
  // }

  #story {
    margin: 0 auto;
  }

  #app.xxs, #app.xs {
    #story {
      // margin-top: 15px;
    }
  }

  .ownershipdiagram-container {
    position: relative;
    margin-top: 64px;
    padding: 0 10px 0 10px;
    container-type: inline-size;
  }

  .ownershipdiagram-lassox-button {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .ownershipdiagram-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    max-width: 100%;
    max-height: 100%;
    filter: blur(1px)
  }

  @container (min-width: 300px) {
    .ownershipdiagram-image {
      filter: blur(1.5px);
    }
  }

  @container (min-width: 450px) {
    .ownershipdiagram-image {
      filter: blur(2px);
    }
  }
</style>
